import Axios from 'axios';

class Announcement {
  announcementID?: string;
  courseID: string;
  expiration: string;
  message: string;

  constructor(announcement: Announcement) {
    this.announcementID = announcement.announcementID;
    this.courseID = announcement.courseID;
    this.expiration = announcement.expiration;
    this.message = announcement.message;
    this.createAnnouncement = this.createAnnouncement.bind(this);
  }

  public static async getAnnouncments(): Promise<Announcement[]> {
    const { announcements = [] } = (await Axios.get('/admin/announcements')).data;
    return announcements;
  }

  public async createAnnouncement(): Promise<any>{
    const res = await Axios.post('/admin/announcement', {
      courseID: this.courseID,
      expiration: this.expiration,
      message: this.message
    });
    return res;
  }

  public async updateAnnouncement(): Promise<any>{
    const res = await Axios.put('/admin/announcement', {
      announcementID: Number(this.announcementID),
      courseID: this.courseID,
      expiration: this.expiration,
      message: this.message
    });
    return res;
  }

  public async deleteAnnouncement(): Promise<any>{
    const res = await Axios.delete('/admin/announcement', {
      data: {announcementID: this.announcementID}
    });
    return res;
  }
}

export default Announcement;
